import React from 'react'
import _ from 'lodash'

import PlanleggingTab from './planlegging'
import Repository from '../felles/repository'
import { resolve } from '../dependencies'
import Loading from '../felles/loading'

import { AppInsights } from 'applicationinsights-js'

export default class PlaneleggingContainer extends React.Component {

    constructor() {
        super()

        this.state = {
            arbeidslister: [],
            laster: false,
            feil: null
        }

        this._leggTilNyArbeidsliste = this._leggTilNyArbeidsliste.bind(this)
        this._hentArbeidslister = this._hentArbeidslister.bind(this)
        this._fjernArbeidsliste = this._fjernArbeidsliste.bind(this)
        this._endreStatusArbeidsListe = this._endreStatusArbeidsListe.bind(this)
        this._endreArbeidsliste = this._endreArbeidsliste.bind(this)     
    }

    componentDidMount() {
        this.setState({
            laster: true
        })
        
        resolve(Repository).hentArbeidslister('').then(liste => this.setState({
            arbeidslister: liste,
            laster: false
        }))
    }

    _leggTilNyArbeidsliste(nyArbeidsliste) {
        this.setState({ laster: true, feil: null })
        resolve(Repository).opprettNyArbeidsliste(nyArbeidsliste)
            .then(() => this._hentArbeidslister())
            .catch(() => this.setState({ laster: false, feil: 'Kunne ikke opprette arbeidsliste' }))
    }

    _hentArbeidslister() {
        return resolve(Repository).hentArbeidslister('').then(liste => this.setState({
            arbeidslister: liste,
            laster: false
        }))
    }

    _fjernArbeidsliste(liste) {
        resolve(Repository).fjernArbeidsliste(liste.Id).then(this._hentArbeidslister)
    }

    _endreStatusArbeidsListe(arbeidslisteFraGUI, status) {
        let arbeidsliste = {
            Id: arbeidslisteFraGUI.Id,
            Tittel: arbeidslisteFraGUI.Tittel,
            Beskrivelse: arbeidslisteFraGUI.Beskrivelse,            
            Startdato: arbeidslisteFraGUI.Startdato,
            StartTidspunkt: arbeidslisteFraGUI.StartTidspunkt,
            SluttTidspunkt: arbeidslisteFraGUI.SluttTidspunkt,
            Status: status,
            ValgteBrukerIder: arbeidslisteFraGUI.ValgteBrukerIder 
        }

        resolve(Repository).oppdateArbeidsliste(arbeidsliste).then(this._hentArbeidslister)
    }

    _endreArbeidsliste(arbeidslisteFraGUI) {
        let arbeidsliste = {
            Id: arbeidslisteFraGUI.Id,
            Tittel: arbeidslisteFraGUI.Tittel,
            Beskrivelse: arbeidslisteFraGUI.Beskrivelse,
            Startdato: arbeidslisteFraGUI.Startdato,
            Status: arbeidslisteFraGUI.status,
            StartTidspunkt: arbeidslisteFraGUI.StartTidspunkt,
            SluttTidspunkt: arbeidslisteFraGUI.SluttTidspunkt,
            ValgteBrukerIder: arbeidslisteFraGUI.ValgteBrukerIder 
        }
        
        var listeSomSkalEndres = _.find(this.state.arbeidslister, a => a.Id === arbeidslisteFraGUI.Id)        
        arbeidsliste.Status = listeSomSkalEndres.Status

        resolve(Repository).oppdateArbeidsliste(arbeidsliste).then(this._hentArbeidslister)
    }

    render() {
        AppInsights.trackPageView("Planlegging")
        return (
                <div>
                    {this.state.feil && (
                        <div className="alert alert-danger">{this.state.feil}</div>
                    )}
                    {
                    this.state.laster ?
                        <Loading tekst="Oppretter arbeidsliste..." /> :

                        <PlanleggingTab arbeidslister={this.state.arbeidslister} fjernArbeidsliste={this._fjernArbeidsliste} settStatusArbeidsListe={this._endreStatusArbeidsListe}
                            hist={this.props.history} leggTilNyArbeidsliste={this._leggTilNyArbeidsliste} endreArbeidsliste={this._endreArbeidsliste} />
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/planlegging/planleggingContainer.jsx